import PropTypes from 'prop-types';
import React from 'react';
import Menu from '../../containers/menu.jsx';
import styles from '../menu/menu.css';

const MenuBarMenu = ({
    children,
    className,
    onRequestClose,
    open,
    place = 'right',
    innerMenuClassName
}) => (
    <div className={className}>
        <Menu
            open={open}
            place={place}
            onRequestClose={onRequestClose}
            className={innerMenuClassName}
        >
            {children}
        </Menu>
    </div>
);

MenuBarMenu.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    innerMenuClassName: PropTypes.string,
    onRequestClose: PropTypes.func,
    open: PropTypes.bool,
    place: PropTypes.oneOf(['left', 'right', 'center'])
};

MenuBarMenu.defaultProps = {
    open: false
};

export default MenuBarMenu;
